// extracted by mini-css-extract-plugin
export default {"header":"head_header__Wt2ym","site-logo":"head_site-logo__01yMC","nav":"head_nav__AWqI5"};